export const translateWeather ={

    "thunderstorm with light rain" : {
        "de": "Gewitter mit leichtem Regen",
        "en": "thunderstorm with light rain",
        "tr": "hafif yağmurlu fırtına",
        "ar": "عاصفة رعدية مع أمطار خفيفة"
    },
    "thunderstorm_with_rain": {
        "de": "Gewitter mit Regen",
        "en": "thunderstorm with rain",
        "tr": "yağmurlu fırtına",
        "ar": "عاصفة رعدية مع المطر"
      },
      "thunderstorm_with_heavy_rain": {
        "de": "Gewitter mit starkem Regen",
        "en": "thunderstorm with heavy rain",
        "tr": "şiddetli yağmurlu fırtına",
        "ar": "عاصفة رعدية مع أمطار غزيرة"
      },
      "light_thunderstorm": {
        "de": "leichtes Gewitter",
        "en": "light thunderstorm",
        "tr": "hafif fırtına",
        "ar": "عاصفة رعدية خفيفة"
      },
      "thunderstorm": {
        "de": "Gewitter",
        "en": "thunderstorm",
        "tr": "fırtına",
        "ar": "عاصفة رعدية"
      },
      "heavy_thunderstorm": {
        "de": "starkes Gewitter",
        "en": "heavy thunderstorm",
        "tr": "şiddetli fırtına",
        "ar": "عاصفة رعدية شديدة"
      },
      "ragged_thunderstorm": {
        "de": "zerrissenes Gewitter",
        "en": "ragged thunderstorm",
        "tr": "dağınık fırtına",
        "ar": "عاصفة رعدية متقطعة"
      },
      "thunderstorm_with_light_drizzle": {
        "de": "Gewitter mit leichtem Nieselregen",
        "en": "thunderstorm with light drizzle",
        "tr": "hafif çisenti ile fırtına",
        "ar": "عاصفة رعدية مع رذاذ خفيف"
      },
      "thunderstorm_with_drizzle": {
        "de": "Gewitter mit Nieselregen",
        "en": "thunderstorm with drizzle",
        "tr": "çisenti ile fırtına",
        "ar": "عاصفة رعدية مع رذاذ"
      },
      "thunderstorm_with_heavy_drizzle": {
        "de": "Gewitter mit starkem Nieselregen",
        "en": "thunderstorm with heavy drizzle",
        "tr": "şiddetli çisenti ile fırtına",
        "ar": "عاصفة رعدية مع رذاذ غزير"
      },
      "light_intensity_drizzle": {
        "de": "leichter Nieselregen",
        "en": "light intensity drizzle",
        "tr": "hafif çisenti",
        "ar": "رذاذ خفيف الشدة"
      },
      "drizzle": {
        "de": "Nieselregen",
        "en": "drizzle",
        "tr": "çisenti",
        "ar": "رذاذ"
      },
      "heavy_intensity_drizzle": {
        "de": "starker Nieselregen",
        "en": "heavy intensity drizzle",
        "tr": "şiddetli çisenti",
        "ar": "رذاذ شديد"
      },
      "light_intensity_drizzle_rain": {
        "de": "leichter Nieselregen",
        "en": "light intensity drizzle rain",
        "tr": "hafif çisenti yağmur",
        "ar": "مطر خفيف الشدة"
      },
      "drizzle_rain": {
        "de": "Nieselregen",
        "en": "drizzle rain",
        "tr": "çisenti yağmur",
        "ar": "مطر رذاذ"
      },
      "heavy_intensity_drizzle_rain": {
        "de": "starker Nieselregen",
        "en": "heavy intensity drizzle rain",
        "tr": "şiddetli çisenti yağmur",
        "ar": "مطر رذاذ شديد"
      },
      "shower_rain_and_drizzle": {
        "de": "Regenschauer und Nieselregen",
        "en": "shower rain and drizzle",
        "tr": "sağanak yağmur ve çisenti",
        "ar": "زخات مطر ورذاذ"
      },
      "heavy_shower_rain_and_drizzle": {
        "de": "starke Regenschauer und Nieselregen",
        "en": "heavy shower rain and drizzle",
        "tr": "şiddetli sağanak yağmur ve çisenti",
        "ar": "زخات مطر شديدة ورذاذ"
      },
      "shower_drizzle": {
        "de": "Nieselregenschauer",
        "en": "shower drizzle",
        "tr": "sağanak çisenti",
        "ar": "رذاذ زخات مطر"
      }
      ,
      "light_rain": {
        "de": "leichter Regen",
        "en": "light rain",
        "tr": "hafif yağmur",
        "ar": "مطر خفيف"
      },
      "moderate_rain": {
        "de": "mäßiger Regen",
        "en": "moderate rain",
        "tr": "orta şiddetli yağmur",
        "ar": "مطر معتدل"
      },
      "heavy_intensity_rain": {
        "de": "starker Regen",
        "en": "heavy intensity rain",
        "tr": "şiddetli yağmur",
        "ar": "مطر غزير"
      },
      "very_heavy_rain": {
        "de": "sehr starker Regen",
        "en": "very heavy rain",
        "tr": "çok şiddetli yağmur",
        "ar": "مطر غزير جدا"
      },
      "extreme_rain": {
        "de": "extremer Regen",
        "en": "extreme rain",
        "tr": "aşırı yağmur",
        "ar": "مطر شديد"
      },
      "freezing_rain": {
        "de": "gefrierender Regen",
        "en": "freezing rain",
        "tr": "dondurucu yağmur",
        "ar": "مطر متجمد"
      },
      "light_intensity_shower_rain": {
        "de": "leichte Regenschauer",
        "en": "light intensity shower rain",
        "tr": "hafif sağanak yağmur",
        "ar": "زخات مطر خفيفة"
      },
      "shower_rain": {
        "de": "Regenschauer",
        "en": "shower rain",
        "tr": "sağanak yağmur",
        "ar": "زخات مطر"
      },
      "heavy_intensity_shower_rain": {
        "de": "starke Regenschauer",
        "en": "heavy intensity shower rain",
        "tr": "şiddetli sağanak yağmur",
        "ar": "زخات مطر شديدة"
      },
      "ragged_shower_rain": {
        "de": "zerrissene Regenschauer",
        "en": "ragged shower rain",
        "tr": "dağınık sağanak yağmur",
        "ar": "زخات مطر متقطعة"
      },
      "light_snow": {
        "de": "leichter Schnee",
        "en": "light snow",
        "tr": "hafif kar",
        "ar": "ثلج خفيف"
      },
      "snow": {
        "de": "Schnee",
        "en": "snow",
        "tr": "kar",
        "ar": "ثلج"
      },
      "heavy_snow": {
        "de": "starker Schnee",
        "en": "heavy snow",
        "tr": "şiddetli kar",
        "ar": "ثلج كثيف"
      },
      "sleet": {
        "de": "Schneeregen",
        "en": "sleet",
        "tr": "sulu kar",
        "ar": "مطر ثلجي"
      },
      "light_shower_sleet": {
        "de": "leichter Schneeregenschauer",
        "en": "light shower sleet",
        "tr": "hafif sulu kar sağanağı",
        "ar": "زخات مطر ثلجي خفيفة"
      },
      "shower_sleet": {
        "de": "Schneeregenschauer",
        "en": "shower sleet",
        "tr": "sulu kar sağanağı",
        "ar": "زخات مطر ثلجي"
      },
      "light_rain_and_snow": {
        "de": "leichter Regen und Schnee",
        "en": "light rain and snow",
        "tr": "hafif yağmur ve kar",
        "ar": "مطر خفيف وثلج"
      },
      "rain_and_snow": {
        "de": "Regen und Schnee",
        "en": "rain and snow",
        "tr": "yağmur ve kar",
        "ar": "مطر وثلج"
      },
      "light_shower_snow": {
        "de": "leichte Schneeschauer",
        "en": "light shower snow",
        "tr": "hafif kar sağanağı",
        "ar": "زخات ثلج خفيفة"
      },
      "shower_snow": {
        "de": "Schneeschauer",
        "en": "shower snow",
        "tr": "kar sağanağı",
        "ar": "زخات ثلج"
      },
      "heavy_shower_snow": {
        "de": "starke Schneeschauer",
        "en": "heavy shower snow",
        "tr": "şiddetli kar sağanağı",
        "ar": "زخات ثلج كثيفة"
      },
      "mist": {
        "de": "Nebel",
        "en": "mist",
        "tr": "sis",
        "ar": "ضباب"
      },
      "smoke": {
        "de": "Rauch",
        "en": "smoke",
        "tr": "duman",
        "ar": "دخان"
      },
      "haze": {
        "de": "Dunst",
        "en": "haze",
        "tr": "pus",
        "ar": "ضباب خفيف"
      },
      "sand_dust_whirls": {
        "de": "Sand-/Staubwirbel",
        "en": "sand/dust whirls",
        "tr": "kum/toz fırtınaları",
        "ar": "دوامات رمل/غبار"
      },
      "fog": {
        "de": "Nebel",
        "en": "fog",
        "tr": "yoğun sis",
        "ar": "ضباب كثيف"
      },
      "sand": {
        "de": "Sand",
        "en": "sand",
        "tr": "kum",
        "ar": "رمل"
      },
      "dust": {
        "de": "Staub",
        "en": "dust",
        "tr": "toz",
        "ar": "غبار"
      },
      "volcanic_ash": {
        "de": "vulkanische Asche",
        "en": "volcanic ash",
        "tr": "volkanik kül",
        "ar": "رماد بركاني"
      },
      "squalls": {
        "de": "Böen",
        "en": "squalls",
        "tr": "ani rüzgarlar",
        "ar": "عواصف"
      },
      "tornado": {
        "de": "Tornado",
        "en": "tornado",
        "tr": "hortum",
        "ar": "إعصار"
      },
      "clear_sky": {
        "de": "klarer Himmel",
        "en": "clear sky",
        "tr": "açık gökyüzü",
        "ar": "سماء صافية"
      },
      "few_clouds": {
        "de": "wenige Wolken",
        "en": "few clouds",
        "tr": "az bulutlu",
        "ar": "غيوم قليلة"
      },
      "scattered_clouds": {
        "de": "vereinzelte Wolken",
        "en": "scattered clouds",
        "tr": "dağınık bulutlar",
        "ar": "غيوم متفرقة"
      },
      "broken_clouds": {
        "de": "aufgelockerte Bewölkung",
        "en": "broken clouds",
        "tr": "parçalı bulutlar",
        "ar": "غيوم متقطعة"
      },
      "overcast_clouds": {
        "de": "bedeckter Himmel",
        "en": "overcast clouds",
        "tr": "kapalı bulutlar",
        "ar": "غيوم ملبدة"
      },
      "mon": {
        "de": "Mo",
        "en": "Mon",
        "tr": "Pzt",
        "ar": "الإثنين"
      },
      "tue": {
        "de": "Di",
        "en": "Tue",
        "tr": "Sal",
        "ar": "الثلاثاء"
      },
      "wed": {
        "de": "Mi",
        "en": "Wed",
        "tr": "Çar",
        "ar": "الأربعاء"
      },
      "thu": {
        "de": "Do",
        "en": "Thu",
        "tr": "Per",
        "ar": "الخميس"
      },
      "fri": {
        "de": "Fr",
        "en": "Fri",
        "tr": "Cum",
        "ar": "الجمعة"
      },
      "sat": {
        "de": "Sa",
        "en": "Sat",
        "tr": "Cmt",
        "ar": "السبت"
      },
      "sun": {
        "de": "So",
        "en": "Sun",
        "tr": "Paz",
        "ar": "الأحد"
      },
      "today": {
        "de": "Heute",
        "en": "Today",
        "tr": "Bugün",
        "ar": "اليوم"
      }
}